@if (label) {
  <div class="label">{{ label }}</div>
}
<div class="input-margin" [ngClass]="{'suffix-icon-box': suffixIconBox}" [ngStyle]="{'margin': customMargin}">
  @if (!passwordFeatures) {
    @if (suffixNzIcon || suffixImgIcon) {
      <nz-input-group [nzSuffix]="basicIconSuffix" [ngStyle]="{'width': customWidth}">
        <ng-container *ngTemplateOutlet="basicInput"></ng-container>
      </nz-input-group>
    } @else {
      <ng-container *ngTemplateOutlet="basicInput"></ng-container>
    }
  } @else {
    <nz-input-group [nzSuffix]="passowrdSuffixTemplate">
      <input
        [type]="passwordVisible() ? 'text' : 'password'"
        nz-input
        [(ngModel)]="value"
        [placeholder]="placeholder ? placeholder : ''"
        [autofocus]="autofocus"
        (ngModelChange)="onChange($event)"
      />
    </nz-input-group>
  }
</div>

<ng-template #basicInput>
  <input #basicInputElement nz-input
    [placeholder]="placeholder ? placeholder : ''"
    [(ngModel)]="value"
    [readonly]="readonly"
    [autofocus]="autofocus"
    [ngClass]="{'pointer': readonly}"
    [ngStyle]="{'width': customWidth}"
    (ngModelChange)="onChange($event)"
  />
</ng-template>

<ng-template #basicIconSuffix>
  @if (suffixNzIcon) {
    <nz-icon
      [nzType]="suffixNzIcon"
      [ngClass]="{'pointer': readonly}"
      (click)="onSuffixClick()"
    />
  }
  @if (suffixImgIcon) {
    <svg-icon
      [src]="'assets/icons/' + suffixImgIcon"
      [ngClass]="{'pointer': readonly}"
      (click)="onSuffixClick()"
    ></svg-icon>
  }
</ng-template>

<ng-template #passowrdSuffixTemplate>
  <nz-icon
    class="ant-input-password-icon"
    [nzType]="passwordVisible() ? 'eye' : 'eye-invisible'"
    (click)="togglePasswordVisibility()"
  />
</ng-template>
